import React, { useState } from "react";
import "./profile_company_page.css";
import Sidebar from "../../components/Sidebar";
import Images from "../../constant/images";
import { useSelector, useDispatch } from "react-redux";
import { setBusinessData } from "../../redux/slices/userSlice";
import { updateBusinessApi, updateProfileApi } from "../../services/apiCall";
import ProfileEditModal from "./component/ProfileEditModal";
import BusinessDetailsModal from "./component/BusinessDetailsModal";
import SecurityPrivacy from "./component/SecurityPrivacy";
import PaymentMethods from "./component/PaymentMethods";
import {
  FiUser,
  FiBriefcase,
  FiShield,
  FiCreditCard,
  FiEdit2,
  FiPhone,
  FiMail,
  FiMapPin,
  FiGlobe,
  FiHash,
  FiCalendar,
} from "react-icons/fi";

const TABS = [
  { id: "profile", label: "Profile Information", icon: FiUser },
  { id: "business", label: "Business Details", icon: FiBriefcase },
  { id: "security", label: "Security & Privacy", icon: FiShield },
  { id: "payment", label: "Payment Methods", icon: FiCreditCard },
];

const InfoRow = ({ icon: Icon, label, value }) => (
  <div className="pcp-info-row">
    <div className="pcp-info-label">
      <Icon size={15} className="pcp-info-icon" />
      <span>{label}</span>
    </div>
    <span className="pcp-info-value">
      {value || <em className="no-data">Not set</em>}
    </span>
  </div>
);

const formatDate = (val) => {
  if (!val) return null;
  return new Date(val).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

export default function ProfileCompanyPage() {
  const [activeTab, setActiveTab] = useState("profile");
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showBusinessModal, setShowBusinessModal] = useState(false);
  const [loadingProfile, setLoadingProfile] = useState(false);
  const [loadingBusiness, setLoadingBusiness] = useState(false);
  const [isPushNotifications, setIsPushNotifications] = useState(() =>
    JSON.parse(localStorage.getItem("PUSH_NOTIFICATIONS") ?? "true"),
  );
  const [isEmailNotifications, setIsEmailNotifications] = useState(() =>
    JSON.parse(localStorage.getItem("EMAIL_NOTIFICATIONS") ?? "false"),
  );

  const dispatch = useDispatch();
  const userData = useSelector((state) => state?.user?.businessData);
  const userId = useSelector((state) => state?.user?.userId);

  const handleSaveProfile = async (updatedData) => {
    try {
      setLoadingProfile(true);
      if (userId) {
        await updateProfileApi(userId, updatedData);
      }
      dispatch(setBusinessData({ ...userData, ...updatedData }));
      setShowProfileModal(false);
    } catch (err) {
      console.error("Failed to update profile", err);
      alert(
        err?.response?.data?.message || "Failed to update profile details.",
      );
    } finally {
      setLoadingProfile(false);
    }
  };

  const handleSaveBusiness = async (updatedData) => {
    console.log("paylaod::::::", updatedData);
    try {
      setLoadingBusiness(true);
      if (userData?.id || userData?._id) {
        const busId = userData?.id || userData?._id;
        await updateBusinessApi(busId, updatedData);
      }
      dispatch(setBusinessData({ ...userData, ...updatedData }));
      setShowBusinessModal(false);
    } catch (err) {
      console.error("Failed to update business", err);
      alert(
        err?.response?.data?.message || "Failed to update business details.",
      );
    } finally {
      setLoadingBusiness(false);
    }
  };

  const handleEmailToggle = (val) => {
    setIsEmailNotifications(val);
    localStorage.setItem("EMAIL_NOTIFICATIONS", JSON.stringify(val));
  };
  const handlePushToggle = (val) => {
    setIsPushNotifications(val);
    localStorage.setItem("PUSH_NOTIFICATIONS", JSON.stringify(val));
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "profile":
        return (
          <div className="pcp-detail-panel">
            <div className="pcp-panel-header">
              <div>
                <h3>Profile Information</h3>
                <p>Your personal account details</p>
              </div>
              <button
                className="pcp-edit-btn"
                onClick={() => setShowProfileModal(true)}
              >
                <FiEdit2 size={14} /> Edit
              </button>
            </div>
            <div className="pcp-info-list">
              <InfoRow icon={FiUser} label="Full Name" value={userData?.name} />
              <InfoRow
                icon={FiMail}
                label="Email Address"
                value={userData?.email}
              />
              <InfoRow
                icon={FiPhone}
                label="Phone Number"
                value={userData?.phone}
              />
            </div>

            <div className="pcp-notifications-section">
              <h4>Notification Preferences</h4>
              <div className="pcp-notif-row">
                <div>
                  <p className="notif-title">Push Notifications</p>
                  <p className="notif-sub">
                    Get notified about important updates
                  </p>
                </div>
                <label className="pcp-toggle">
                  <input
                    type="checkbox"
                    checked={isPushNotifications}
                    onChange={(e) => handlePushToggle(e.target.checked)}
                  />
                  <span className="pcp-slider" />
                </label>
              </div>
              <div className="pcp-notif-row">
                <div>
                  <p className="notif-title">Email Notifications</p>
                  <p className="notif-sub">Receive updates via email</p>
                </div>
                <label className="pcp-toggle">
                  <input
                    type="checkbox"
                    checked={isEmailNotifications}
                    onChange={(e) => handleEmailToggle(e.target.checked)}
                  />
                  <span className="pcp-slider" />
                </label>
              </div>
            </div>
          </div>
        );

      case "business":
        return (
          <div className="pcp-detail-panel">
            <div className="pcp-panel-header">
              <div>
                <h3>Business Details</h3>
                <p>Your company registration and financial information</p>
              </div>
              <button
                className="pcp-edit-btn"
                onClick={() => setShowBusinessModal(true)}
              >
                <FiEdit2 size={14} /> Edit
              </button>
            </div>
            <div className="pcp-info-list">
              <InfoRow
                icon={FiBriefcase}
                label="Business Name"
                value={userData?.name}
              />
              <InfoRow icon={FiMail} label="Email" value={userData?.email} />
              <InfoRow icon={FiPhone} label="Phone" value={userData?.phone} />
              <InfoRow
                icon={FiMapPin}
                label="Post Code"
                value={userData?.postCode}
              />
              <InfoRow
                icon={FiMapPin}
                label="Address"
                value={userData?.address}
              />
              <InfoRow
                icon={FiHash}
                label="Registration No."
                value={userData?.registrationNo}
              />
              <InfoRow
                icon={FiHash}
                label="VAT Number"
                value={userData?.vatNo}
              />
              <InfoRow
                icon={FiGlobe}
                label="Website"
                value={userData?.website || userData?.websiteUrl}
              />
            </div>

            <div className="pcp-financial-section">
              <h4>Financial Year</h4>
              <div className="pcp-financial-grid">
                <div className="pcp-fin-card">
                  <FiCalendar size={18} className="pcp-fin-icon" />
                  <span className="pcp-fin-label">Year Start</span>
                  <span className="pcp-fin-value">
                    {formatDate(userData?.financialYearStart) || "Not set"}
                  </span>
                </div>
                <div className="pcp-fin-card">
                  <FiCalendar size={18} className="pcp-fin-icon" />
                  <span className="pcp-fin-label">Year End</span>
                  <span className="pcp-fin-value">
                    {formatDate(userData?.financialYearEnd) || "Not set"}
                  </span>
                </div>
                <div className="pcp-fin-card">
                  <FiCalendar size={18} className="pcp-fin-icon" />
                  <span className="pcp-fin-label">Tax Start</span>
                  <span className="pcp-fin-value">
                    {formatDate(userData?.taxStartDate) || "Not set"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        );

      case "security":
        return (
          <div className="pcp-detail-panel">
            <div className="pcp-panel-header">
              <div>
                <h3>Security & Privacy</h3>
                <p>Manage your password, 2FA, and active sessions</p>
              </div>
            </div>
            <SecurityPrivacy />
          </div>
        );

      case "payment":
        return (
          <div className="pcp-detail-panel">
            <div className="pcp-panel-header">
              <div>
                <h3>Payment Methods</h3>
                <p>Manage your saved payment methods</p>
              </div>
            </div>
            <PaymentMethods />
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="app">
      <Sidebar />
      <div className="main">
        <div className="pcp-page-header">
          <div className="pcp-hero">
            <div className="pcp-avatar-circle">
              <img src={Images.logo} alt="profile" className="pcp-avatar-img" />
            </div>
            <div className="pcp-hero-info">
              <h2>{userData?.name || "—"}</h2>
              <p>{userData?.email || "—"}</p>
              {userData?.status && (
                <span
                  className={`pcp-status-badge ${userData.status.toLowerCase()}`}
                >
                  {userData.status}
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="pcp-content">
          <div className="pcp-tab-bar">
            {TABS.map(({ id, label, icon: Icon }) => (
              <button
                key={id}
                className={`pcp-tab-btn ${activeTab === id ? "active" : ""}`}
                onClick={() => setActiveTab(id)}
              >
                <Icon size={16} />
                <span>{label}</span>
              </button>
            ))}
          </div>
          <div className="pcp-tab-body">{renderTabContent()}</div>
        </div>
      </div>

      {showProfileModal && (
        <ProfileEditModal
          userData={userData}
          onClose={() => setShowProfileModal(false)}
          onSave={handleSaveProfile}
          loading={loadingProfile}
        />
      )}
      {showBusinessModal && (
        <BusinessDetailsModal
          userData={userData}
          onClose={() => setShowBusinessModal(false)}
          onSave={handleSaveBusiness}
          loading={loadingBusiness}
        />
      )}
    </div>
  );
}
